"use client";
import * as React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const LoadingDialog = ({ ...props }) => {
  const { lang, isOpen } = props;

  //const [open, setOpen] = React.useState(isOpen);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={isOpen}
        //onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            width: 200,
            height: 200,
          },
        }}
      >
        <span className="w-20 h-20 m-auto mb-10">
          <span className="animate-spin border-4 border-warning border-l-transparent rounded-full w-full h-full inline-block align-middle m-auto mb-10"></span>
        </span>
      </Dialog>
    </React.Fragment>
  );
};

LoadingDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default LoadingDialog;
